import { create } from "zustand";

type onOpenProps = {
  publicUrl?: string;
  isPublic?: boolean;
  studySetId?: string;
  type?: "personal" | "liked" | "public";
  isAuthenticated: boolean;
};

type ModalStore = {
  isAuthenticated: boolean;
  type?: "personal" | "liked" | "public";
  publicUrl?: string;
  isPublic?: boolean;
  studySetId?: string;
  isOpen: boolean;
  onOpen: ({ publicUrl, isPublic, studySetId, type }: onOpenProps) => void;
  onClose: () => void;
};

const useShareStudySetModal = create<ModalStore>((set) => ({
  isOpen: false,
  isAuthenticated: false,
  onOpen: ({ publicUrl, isPublic, studySetId, type, isAuthenticated }) =>
    set({
      isOpen: true,
      publicUrl,
      isPublic,
      studySetId,
      type,
      isAuthenticated,
    }),
  onClose: () => set({ isOpen: false }),
}));

export default useShareStudySetModal;
